import { ComponentPropsWithoutRef } from 'react';
import { StyledTR } from './styles';

export const TR = (props: ComponentPropsWithoutRef<'tr'>) => <StyledTR {...props} />;
